var styles = {
  "Picker": "_Picker_ze16o_34",
  "Row": "_Row_ze16o_38",
  "Preset": "_Preset_ze16o_47",
  "Container": "_Container_ze16o_65"
};

export { styles as default };
